import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class AnchorConverter extends CmsConverterService<AnchorData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      anchorId: formData.st_anchor_link ?? defaultTextInput
    }
  }
}

export const ANCHOR_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, AnchorData>>('AnchorConverter')

export interface AnchorData extends ConvertedComponentData {
  anchorId: TextInput;
}
